<template>
  <nav
    v-if="seo && $route.name !== 'home' && $route.name !== 'not-found' && !seo.standalone && !isBookingLoss"
    class="seo-breadcrumbs"
    :dir="seo.lang === 'ar' ? 'rtl' : 'ltr'"
    :aria-label="seo.lang === 'ar' ? 'مسار التنقل' : 'Breadcrumb'"
  >
    <ol>
      <li><router-link :to="{ name: 'home' }">{{ seo.lang === 'ar' ? 'الأدوات' : 'Tools Hub' }}</router-link></li>
      <li aria-hidden="true">/</li>
      <li v-if="categoryLabel"><router-link :to="categoryRoute">{{ categoryLabel }}</router-link></li>
      <li v-if="categoryLabel" aria-hidden="true">/</li>
      <li aria-current="page">{{ seo.label }}</li>
    </ol>
  </nav>
</template>

<script>
import { routeSeo } from '@/seo/routeSeo'
import { tools, TOOL_CATEGORIES } from '@/tools/catalog'

export default {
  computed: {
    isBookingLoss() {
      return ['booking-loss-calculator-ar', 'booking-loss-calculator-en'].includes(this.$route.name)
    },
    seo() {
      return routeSeo[this.$route.name]
    },
    categoryLabel() {
      if (!this.seo) return ''
      const tool = tools.find(item => item.routeNameEn === this.$route.name || item.routeNameAr === this.$route.name)
      if (!tool) return ''
      const category = TOOL_CATEGORIES.find(item => item.id === tool.category)
      return category ? category[this.seo.lang === 'ar' ? 'ar' : 'en'] : ''
    },
    categoryRoute() {
      const tool = tools.find(item => item.routeNameEn === this.$route.name || item.routeNameAr === this.$route.name)
      return { name: 'home', query: tool ? { category: tool.category } : {}, hash: '#tools' }
    }
  }
}
</script>

<style scoped>
.seo-breadcrumbs {
  margin: 0;
  padding: 0 20px;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(226, 232, 240, 0.9);
}
.seo-breadcrumbs ol {
  display: flex;
  gap: 8px;
  align-items: center;
  width: min(1180px, 100%);
  min-height: 42px;
  margin: 0 auto;
  padding: 7px 0;
  list-style: none;
}
.seo-breadcrumbs a {
  color: #24365c;
  font-weight: 700;
  text-decoration: none;
}

.seo-breadcrumbs a:hover {
  color: #3a7afe;
}
</style>
